import React, { useState } from 'react';

import { check } from '@/assets/icons';
import { Label } from '@/components/shared/Inputs/Label';
import {
	SettingsList,
	SettingsListItems,
} from '@/components/shared/SettingCard';
import { SingleActionLayout } from '@/components/shared/SingleActionLayout/SingleActionLayout';
import { ROTATION_STATUSES } from '@/config/constants';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { SvgIcon } from '@material-ui/core';

import { IPropsSongModalDisplay } from '../SongModalPanel';
import styles from './RotationStatus.module.scss';

export const RotationStatus: React.FC<IPropsSongModalDisplay> = ({
	openedSong,
	updateTeamSong,
	popDisplayState,
}) => {
	const { rotationStatus, name } = openedSong;
	const [touched, setTouched] = useState(false);
	const [status, setStatus] = useState(rotationStatus);
	const fireSaveRotationStatusEvent = useAnalyticsEvent(
		'View_Song_Save_Rotation_Status',
	);

	const statusItems: SettingsListItems = ROTATION_STATUSES.map(
		({ key, capitalisedLabel, description }) => ({
			type: 'setting' as const,
			title: capitalisedLabel,
			subtitle: description,
			trailingComponent:
				key === status ? (
					<div className={styles['status-check--selected']}>
						<SvgIcon component={check} />
					</div>
				) : undefined,
			onClick: () => {
				setTouched(true);
				setStatus(key);
			},
		}),
	);

	return (
		<SingleActionLayout
			noPadding
			actionDisabled={!touched}
			actionLabel="Save Rotation Status"
			onActionClick={() => {
				updateTeamSong({
					rotationStatus: status,
				});
				popDisplayState();
				fireSaveRotationStatusEvent();
			}}
		>
			<div className={styles['root']}>
				<Label className={styles['label']}>
					Select how often you want to play <span className={styles['song-name']}>{name}</span>. This helps AI and your team optimize song cadence.
				</Label>
			</div>
			<div className={styles['list-wrapper']}>
				<SettingsList items={statusItems} />
			</div>
		</SingleActionLayout>
	);
};
